import { useTranslation } from 'next-i18next'
import { Flex, Text } from '@chakra-ui/react'
import {
  FacebookShareButton,
  PinterestShareButton,
  EmailShareButton,
} from 'next-share'
import { useRouter } from '_app/hooks/useRouter'

import { FacebookIcon, PinterestIcon, ShareIcon } from '_app/components/Icons'

const ShareLinks = ({
  image,
  name,
}: {
  image?: string | null;
  name?: string | null;
}) => {
  const { t } = useTranslation('product')
  const { asPath } = useRouter()

  return (
    <Flex>
      <Text mr={3} textStyle="bodyLight">
        {t('SHARE')}:
      </Text>
      <FacebookShareButton url={`https://lilou.pl${asPath}`}>
        <FacebookIcon mr={3} />
      </FacebookShareButton>
      <PinterestShareButton
        media={image ?? ''}
        description={name ?? ''}
        url={`https://lilou.pl${asPath}`}
      >
        <PinterestIcon mr={3} />
      </PinterestShareButton>
      <EmailShareButton
        subject={`${t('SENDING_SOMETHING_THAT_WILL_AMAZE_YOU')}`}
        url={`${t('SENDING_SOMETHING_THAT_WILL_AMAZE_YOU')}: https://lilou.pl${asPath}`}
      >
        <ShareIcon mr={3} />
      </EmailShareButton>
    </Flex>
  )
}

export default ShareLinks
